import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faArrowTurnDownLeft } from '@fortawesome/pro-regular-svg-icons/faArrowTurnDownLeft';
import { faBackspace } from '@fortawesome/pro-regular-svg-icons/faBackspace';

import { Icon, Flex, Text, HStack, Center, useToken } from 'quotient';

type Props = {};

export const CommandBarFooter: React.VFC<Props> = () => {
  const primaryNeutral400 = useToken('colors', 'primaryNeutral.400');
  return (
    <Flex
      alignItems="center"
      bg="primaryNeutral.50"
      borderTop={`1px solid ${primaryNeutral400}`}
      color="gray.700"
      direction="row"
      padding={4}
    >
      <HStack alignItems="center" flex="3" justifyContent="center" spacing={2}>
        <Center bg="gray.300" borderRadius="4px" color="gray.600" h="24px" w="24px">
          <Icon icon={faChevronUp} size="sm" />
        </Center>
        <Center bg="gray.300" borderRadius="4px" color="gray.600" h="24px" w="24px">
          <Icon icon={faChevronDown} size="sm" />
        </Center>
        <Text>To navigate</Text>
      </HStack>
      <HStack alignItems="center" flex="1" justifyContent="center" spacing={2}>
        <Center bg="gray.300" borderRadius="4px" color="gray.600" h="24px" w="24px">
          <Icon icon={faArrowTurnDownLeft} size="sm" />
        </Center>
        <Text>Select</Text>
      </HStack>
      <HStack alignItems="center" flex="2" justifyContent="center" spacing={2}>
        <Center bg="gray.300" borderRadius="4px" color="gray.600" h="24px" w="24px">
          <Icon icon={faBackspace} size="sm" />
        </Center>
        <Text>Back</Text>
      </HStack>
      <HStack alignItems="center" flex="2" justifyContent="center" spacing={2}>
        <Center bg="gray.300" borderRadius="4px" color="gray.600" h="24px" px={2}>
          <Text variant="">esc</Text>
        </Center>
        <Text>Dismiss</Text>
      </HStack>
    </Flex>
  );
};
